var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkCloudSvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1800",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#150e2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#13131D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#0f0c1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#09090F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowTL",
    cx: "0%",
    cy: "0%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A78BFA",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#7C5CBF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7C5CBF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowBR",
    cx: "100%",
    cy: "100%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#818CF8",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#6D5ACF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6D5ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowBL",
    cx: "0%",
    cy: "100%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A78BFA",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#8B6FC0",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B6FC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowTR",
    cx: "100%",
    cy: "0%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#818CF8",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#6D5ACF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6D5ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f20"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f35"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1800,
    fill: "url(#sky)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1800,
    fill: "url(#glowTL)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1800,
    fill: "url(#glowBR)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1800,
    fill: "url(#glowBL)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1800,
    fill: "url(#glowTR)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 60,
    r: 1.5,
    fill: "#E4E4ED",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 40,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 55,
    r: 1.2,
    fill: "#E4E4ED",
    opacity: 0.35
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 35,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 50,
    r: 1.5,
    fill: "#E4E4ED",
    opacity: 0.45
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 65,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 170,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 150,
    r: 1.2,
    fill: "#E4E4ED",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1350,
    cy: 140,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 310,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 290,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 500,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.15
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1400,
    cy: 450,
    r: 1.2,
    fill: "#E4E4ED",
    opacity: 0.2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 650,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.15
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 800,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.12
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 750,
    r: 1,
    fill: "#E4E4ED",
    opacity: 0.15
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 80,
    r: 2,
    fill: "#A78BFA",
    opacity: 0.6,
    filter: "url(#f3)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 60,
    r: 2.5,
    fill: "#818CF8",
    opacity: 0.5,
    filter: "url(#f3)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 180,
    r: 2,
    fill: "#A78BFA",
    opacity: 0.4,
    filter: "url(#f3)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1300,
    cy: 200,
    r: 1.8,
    fill: "#818CF8",
    opacity: 0.35,
    filter: "url(#f3)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 420,
    r: 1.5,
    fill: "#A78BFA",
    opacity: 0.3,
    filter: "url(#f3)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 290,
    rx: 260,
    ry: 85,
    fill: "#2A2040",
    opacity: 0.5,
    filter: "url(#f8)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220,
    cy: 250,
    rx: 110,
    ry: 75,
    fill: "#342855",
    opacity: 0.6,
    filter: "url(#f5)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 235,
    rx: 120,
    ry: 80,
    fill: "#382C58",
    opacity: 0.65,
    filter: "url(#f5)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 255,
    rx: 95,
    ry: 65,
    fill: "#302648",
    opacity: 0.55,
    filter: "url(#f5)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 270,
    rx: 130,
    ry: 70,
    fill: "#342855",
    opacity: 0.6,
    filter: "url(#f5)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 245,
    rx: 60,
    ry: 45,
    fill: "#3E3060",
    opacity: 0.5,
    filter: "url(#f3)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 225,
    rx: 70,
    ry: 50,
    fill: "#443468",
    opacity: 0.55,
    filter: "url(#f3)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 235,
    rx: 55,
    ry: 42,
    fill: "#3A2E5A",
    opacity: 0.5,
    filter: "url(#f3)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290,
    cy: 230,
    rx: 100,
    ry: 35,
    fill: "#A78BFA",
    opacity: 0.08,
    filter: "url(#f5)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 310,
    rx: 220,
    ry: 40,
    fill: "#A78BFA",
    opacity: 0.05,
    filter: "url(#f12)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150,
    cy: 200,
    rx: 220,
    ry: 75,
    fill: "#2A2040",
    opacity: 0.45,
    filter: "url(#f8)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100,
    cy: 180,
    rx: 100,
    ry: 70,
    fill: "#342855",
    opacity: 0.58,
    filter: "url(#f5)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1200,
    cy: 170,
    rx: 110,
    ry: 75,
    fill: "#382C58",
    opacity: 0.62,
    filter: "url(#f5)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1300,
    cy: 190,
    rx: 90,
    ry: 60,
    fill: "#302648",
    opacity: 0.52,
    filter: "url(#f5)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1190,
    cy: 175,
    rx: 60,
    ry: 42,
    fill: "#443468",
    opacity: 0.5,
    filter: "url(#f3)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150,
    cy: 170,
    rx: 80,
    ry: 30,
    fill: "#818CF8",
    opacity: 0.06,
    filter: "url(#f5)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 760,
    cy: 310,
    rx: 100,
    ry: 45,
    fill: "#2A2040",
    opacity: 0.4,
    filter: "url(#f8)"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 740,
    cy: 295,
    rx: 65,
    ry: 42,
    fill: "#342855",
    opacity: 0.55,
    filter: "url(#f5)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 300,
    rx: 55,
    ry: 38,
    fill: "#302648",
    opacity: 0.5,
    filter: "url(#f5)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770,
    cy: 292,
    rx: 40,
    ry: 28,
    fill: "#3E3060",
    opacity: 0.45,
    filter: "url(#f3)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1420,
    cy: 350,
    rx: 120,
    ry: 70,
    fill: "#2A2040",
    opacity: 0.4,
    filter: "url(#f8)"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1430,
    cy: 335,
    rx: 80,
    ry: 55,
    fill: "#342855",
    opacity: 0.55,
    filter: "url(#f5)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1400,
    cy: 340,
    rx: 60,
    ry: 45,
    fill: "#302648",
    opacity: 0.5,
    filter: "url(#f5)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 480,
    rx: 110,
    ry: 40,
    fill: "#2A2040",
    opacity: 0.35,
    filter: "url(#f8)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 470,
    rx: 70,
    ry: 35,
    fill: "#342855",
    opacity: 0.5,
    filter: "url(#f5)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 450,
    rx: 70,
    ry: 35,
    fill: "#2A2040",
    opacity: 0.35,
    filter: "url(#f5)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 530,
    cy: 442,
    rx: 45,
    ry: 28,
    fill: "#342855",
    opacity: 0.48,
    filter: "url(#f3)"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 920,
    cy: 420,
    rx: 65,
    ry: 32,
    fill: "#2A2040",
    opacity: 0.32,
    filter: "url(#f5)"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 925,
    cy: 414,
    rx: 40,
    ry: 25,
    fill: "#342855",
    opacity: 0.45,
    filter: "url(#f3)"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1300,
    cy: 460,
    rx: 90,
    ry: 35,
    fill: "#2A2040",
    opacity: 0.3,
    filter: "url(#f8)"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 620,
    rx: 140,
    ry: 30,
    fill: "#2A2040",
    opacity: 0.25,
    filter: "url(#f8)"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 700,
    cy: 580,
    rx: 180,
    ry: 28,
    fill: "#2A2040",
    opacity: 0.18,
    filter: "url(#f12)"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1200,
    cy: 650,
    rx: 160,
    ry: 32,
    fill: "#2A2040",
    opacity: 0.22,
    filter: "url(#f8)"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 680,
    cy: 720,
    rx: 120,
    ry: 50,
    fill: "#2A2040",
    opacity: 0.35,
    filter: "url(#f8)"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 660,
    cy: 710,
    rx: 75,
    ry: 42,
    fill: "#342855",
    opacity: 0.48,
    filter: "url(#f5)"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 715,
    rx: 65,
    ry: 38,
    fill: "#302648",
    opacity: 0.44,
    filter: "url(#f5)"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 685,
    cy: 705,
    rx: 45,
    ry: 28,
    fill: "#3E3060",
    opacity: 0.4,
    filter: "url(#f3)"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 680,
    cy: 700,
    rx: 60,
    ry: 20,
    fill: "#A78BFA",
    opacity: 0.05,
    filter: "url(#f5)"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 780,
    rx: 100,
    ry: 45,
    fill: "#2A2040",
    opacity: 0.3,
    filter: "url(#f8)"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 770,
    rx: 65,
    ry: 38,
    fill: "#342855",
    opacity: 0.45,
    filter: "url(#f5)"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210,
    cy: 772,
    rx: 55,
    ry: 35,
    fill: "#302648",
    opacity: 0.42,
    filter: "url(#f5)"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1250,
    cy: 800,
    rx: 110,
    ry: 48,
    fill: "#2A2040",
    opacity: 0.3,
    filter: "url(#f8)"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1230,
    cy: 790,
    rx: 70,
    ry: 40,
    fill: "#342855",
    opacity: 0.45,
    filter: "url(#f5)"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1285,
    cy: 792,
    rx: 60,
    ry: 36,
    fill: "#302648",
    opacity: 0.42,
    filter: "url(#f5)"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 870,
    rx: 700,
    ry: 40,
    fill: "#A78BFA",
    filter: "url(#f35)",
    opacity: 0.06
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 950,
    rx: 600,
    ry: 35,
    fill: "#818CF8",
    filter: "url(#f35)",
    opacity: 0.04
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 680,
    rx: 50,
    ry: 25,
    fill: "#2A2040",
    opacity: 0.3,
    filter: "url(#f5)"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1050,
    cy: 730,
    rx: 45,
    ry: 22,
    fill: "#2A2040",
    opacity: 0.28,
    filter: "url(#f5)"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 550,
    cy: 850,
    rx: 55,
    ry: 28,
    fill: "#2A2040",
    opacity: 0.25,
    filter: "url(#f5)"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 900,
    cy: 880,
    rx: 50,
    ry: 25,
    fill: "#2A2040",
    opacity: 0.22,
    filter: "url(#f5)"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 350,
    cy: 950,
    rx: 48,
    ry: 24,
    fill: "#2A2040",
    opacity: 0.2,
    filter: "url(#f5)"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100,
    cy: 960,
    rx: 52,
    ry: 26,
    fill: "#2A2040",
    opacity: 0.2,
    filter: "url(#f5)"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 1080,
    rx: 130,
    ry: 55,
    fill: "#2A2040",
    opacity: 0.35,
    filter: "url(#f8)"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 420,
    cy: 1068,
    rx: 80,
    ry: 45,
    fill: "#342855",
    opacity: 0.48,
    filter: "url(#f5)"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 490,
    cy: 1070,
    rx: 70,
    ry: 42,
    fill: "#302648",
    opacity: 0.44,
    filter: "url(#f5)"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 1063,
    rx: 50,
    ry: 30,
    fill: "#3E3060",
    opacity: 0.4,
    filter: "url(#f3)"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1000,
    cy: 1100,
    rx: 120,
    ry: 50,
    fill: "#2A2040",
    opacity: 0.33,
    filter: "url(#f8)"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 975,
    cy: 1088,
    rx: 75,
    ry: 42,
    fill: "#342855",
    opacity: 0.46,
    filter: "url(#f5)"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1040,
    cy: 1090,
    rx: 65,
    ry: 38,
    fill: "#302648",
    opacity: 0.42,
    filter: "url(#f5)"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 1050,
    rx: 55,
    ry: 28,
    fill: "#2A2040",
    opacity: 0.26,
    filter: "url(#f5)"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1350,
    cy: 1070,
    rx: 50,
    ry: 25,
    fill: "#2A2040",
    opacity: 0.24,
    filter: "url(#f5)"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 1150,
    rx: 60,
    ry: 30,
    fill: "#2A2040",
    opacity: 0.22,
    filter: "url(#f5)"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 1400,
    rx: 320,
    ry: 95,
    fill: "#1E1830",
    opacity: 0.5,
    filter: "url(#f12)"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 1370,
    rx: 300,
    ry: 90,
    fill: "#2A2040",
    opacity: 0.5,
    filter: "url(#f8)"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 1350,
    rx: 95,
    ry: 70,
    fill: "#342855",
    opacity: 0.58,
    filter: "url(#f5)"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 1330,
    rx: 100,
    ry: 75,
    fill: "#382C58",
    opacity: 0.62,
    filter: "url(#f5)"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290,
    cy: 1320,
    rx: 110,
    ry: 82,
    fill: "#3E3060",
    opacity: 0.65,
    filter: "url(#f5)"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 1335,
    rx: 100,
    ry: 72,
    fill: "#382C58",
    opacity: 0.6,
    filter: "url(#f5)"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 480,
    cy: 1355,
    rx: 85,
    ry: 60,
    fill: "#342855",
    opacity: 0.52,
    filter: "url(#f5)"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 550,
    cy: 1370,
    rx: 65,
    ry: 45,
    fill: "#2A2040",
    opacity: 0.45,
    filter: "url(#f5)"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 1325,
    rx: 65,
    ry: 48,
    fill: "#443468",
    opacity: 0.5,
    filter: "url(#f3)"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 1322,
    rx: 60,
    ry: 45,
    fill: "#443468",
    opacity: 0.48,
    filter: "url(#f3)"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 1310,
    rx: 100,
    ry: 25,
    fill: "#A78BFA",
    opacity: 0.06,
    filter: "url(#f5)"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 1410,
    rx: 260,
    ry: 45,
    fill: "#A78BFA",
    opacity: 0.04,
    filter: "url(#f12)"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150,
    cy: 1420,
    rx: 340,
    ry: 100,
    fill: "#1E1830",
    opacity: 0.5,
    filter: "url(#f12)"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1130,
    cy: 1390,
    rx: 310,
    ry: 95,
    fill: "#2A2040",
    opacity: 0.5,
    filter: "url(#f8)"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 950,
    cy: 1375,
    rx: 90,
    ry: 65,
    fill: "#342855",
    opacity: 0.55,
    filter: "url(#f5)"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1040,
    cy: 1355,
    rx: 100,
    ry: 75,
    fill: "#382C58",
    opacity: 0.6,
    filter: "url(#f5)"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150,
    cy: 1345,
    rx: 115,
    ry: 85,
    fill: "#3E3060",
    opacity: 0.65,
    filter: "url(#f5)"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1260,
    cy: 1355,
    rx: 105,
    ry: 75,
    fill: "#382C58",
    opacity: 0.6,
    filter: "url(#f5)"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1360,
    cy: 1370,
    rx: 90,
    ry: 65,
    fill: "#342855",
    opacity: 0.55,
    filter: "url(#f5)"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1430,
    cy: 1385,
    rx: 70,
    ry: 50,
    fill: "#2A2040",
    opacity: 0.48,
    filter: "url(#f5)"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100,
    cy: 1348,
    rx: 65,
    ry: 48,
    fill: "#443468",
    opacity: 0.5,
    filter: "url(#f3)"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1200,
    cy: 1345,
    rx: 60,
    ry: 45,
    fill: "#443468",
    opacity: 0.48,
    filter: "url(#f3)"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150,
    cy: 1335,
    rx: 80,
    ry: 25,
    fill: "#818CF8",
    opacity: 0.05,
    filter: "url(#f5)"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150,
    cy: 1440,
    rx: 280,
    ry: 50,
    fill: "#A78BFA",
    opacity: 0.04,
    filter: "url(#f12)"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 700,
    cy: 1480,
    rx: 140,
    ry: 60,
    fill: "#2A2040",
    opacity: 0.4,
    filter: "url(#f8)"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 670,
    cy: 1468,
    rx: 80,
    ry: 48,
    fill: "#342855",
    opacity: 0.52,
    filter: "url(#f5)"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 740,
    cy: 1465,
    rx: 75,
    ry: 45,
    fill: "#302648",
    opacity: 0.48,
    filter: "url(#f5)"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 810,
    cy: 1475,
    rx: 65,
    ry: 40,
    fill: "#2A2040",
    opacity: 0.42,
    filter: "url(#f5)"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 700,
    cy: 1462,
    rx: 50,
    ry: 30,
    fill: "#3E3060",
    opacity: 0.4,
    filter: "url(#f3)"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 1280,
    rx: 75,
    ry: 38,
    fill: "#2A2040",
    opacity: 0.28,
    filter: "url(#f5)"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 850,
    cy: 1250,
    rx: 65,
    ry: 32,
    fill: "#2A2040",
    opacity: 0.25,
    filter: "url(#f5)"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 1220,
    rx: 70,
    ry: 35,
    fill: "#2A2040",
    opacity: 0.24,
    filter: "url(#f5)"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1350,
    cy: 1200,
    rx: 60,
    ry: 30,
    fill: "#2A2040",
    opacity: 0.22,
    filter: "url(#f5)"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 1720,
    rx: 800,
    ry: 100,
    fill: "#2A1F45",
    filter: "url(#f35)",
    opacity: 0.4
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 720,
    cy: 1780,
    rx: 700,
    ry: 70,
    fill: "#1E1535",
    filter: "url(#f35)",
    opacity: 0.3
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 1760,
    rx: 400,
    ry: 60,
    fill: "#A78BFA",
    filter: "url(#f35)",
    opacity: 0.04
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100,
    cy: 1750,
    rx: 450,
    ry: 65,
    fill: "#818CF8",
    filter: "url(#f35)",
    opacity: 0.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCloudSvgBg);
export default __webpack_public_path__ + "static/media/dark-cloud-svg-bg.5582d27e7aa6e274d3672a961e103fd7.svg";
export { ForwardRef as ReactComponent };